import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { OldLegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';

@Injectable()
export class AutoComplateService extends OldLegacyBaseApiService<any> {
	public skuId: string;
	override get apiUrl() {
		return Urls.BASE_URL.toString();
	}

	// public getSku(query: any): Observable<any[]> {
	//   query = query || {};
	//   query.valid = true;
	//   return this._restClientService.post(
	//     `${this.apiUrl}/main/combo/sku`,
	//     JSON.stringify(query)
	//   );
	// }

	// public getSku(query: any): Observable<any[]> {
	//   query = query || {};
	//   query.valid = true;
	//   return this._restClientService.post(
	//     `${this.apiUrl}/sku/combo/sku`,
	//     JSON.stringify(query)
	//   );
	// }

	public getCustomers(query: any): Observable<any[]> {
		return this._restClientService.post(`${this.apiUrl}/main/combo/customer`, JSON.stringify(query));
	}

	public getSuppliers(query: any): Observable<any[]> {
		return this._restClientService.post(`${this.apiUrl}/main/combo/supplier`, JSON.stringify(query));
	}

	public getGroupHierarchy(query: any): Observable<any[]> {
		return this._restClientService.post(`${this.apiUrl}/sku/combo/group-hierarchy`, JSON.stringify(query));
	}
	public getSkuDef(query: any): Observable<any[]> {
		return this._restClientService.post(`${this.apiUrl}/sku/combo/sku`, JSON.stringify(query));
	}

	public getSkuUm(query: any): Observable<any[]> {
		if (!this.skuId) {
			throw new Error('Invoice Id is not assigned.');
		}
		return this._restClientService.post(`${this.apiUrl}/sku/combo/sku/${this.skuId}/um`, JSON.stringify(query));
	}

	public getUm(query: any): Observable<any[]> {
		return this._restClientService.post(`${this.apiUrl}/main/combo/unit-of-measurement`, JSON.stringify(query));
	}

	public getTypeDetail(definitionTypeId: any): Observable<any[]> {
		return this._restClientService.post(`${this.apiUrl}/main/combo/type-detail`, JSON.stringify({ definitionTypeId }));
	}
}
